import { render, staticRenderFns } from "./EditProgram.vue?vue&type=template&id=a3b059a6&scoped=true"
import script from "./EditProgram.vue?vue&type=script&lang=js"
export * from "./EditProgram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b059a6",
  null
  
)

export default component.exports